import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const BankIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M11.9959 7H12.0049" stroke="currentColor"></path>
      <path d="M5 9.99512V18.9998M9 9.99512V18.9998" stroke="currentColor"></path>
      <path d="M15 9.99512V18.9998M19 9.99512V18.9998" stroke="currentColor"></path>
      <path d="M21 19H3L3.0003 21.9999H21V19Z" stroke="currentColor"></path>
      <path d="M3 7L12 2L21 7V9.99502H3V7Z" stroke="currentColor"></path>
    </SvgIcon>
  )
}
